<template>
  <div>
    <b-pagination
      v-if="total"
      first-number
      last-number
      :per-page="perPage"
      :size="size"
      :value="value"
      :align="align"
      :total-rows="total"
      :limit="3"
      @change="(val) => $emit('change', val)"
    >
      <template #prev-text>
        <a
          class="page-link"
          aria-label="Previous"
        >
          <span aria-hidden="true"><i
            class="fa fa-angle-left"
            aria-hidden="true"
          /></span>
        </a>
      </template>
      <template #next-text>
        <a
          class="page-link"
          aria-label="Next"
        >
          <span aria-hidden="true"><i
            class="fa fa-angle-right"
            aria-hidden="true"
          /></span>
        </a>
      </template>
    </b-pagination>
  </div>
</template>
<script>
export default {
  name: "BasePagination",
  props: {
    pageCount: {
      type: Number,
      default: 0,
      description:
        "Pagination page count. This should be specified in combination with perPage"
    },
    perPage: {
      type: Number,
      default: 10,
      description:
        "Pagination per page. Should be specified with total or pageCount"
    },
    total: {
      type: Number,
      default: 0,
      description:
        "Can be specified instead of pageCount. The page count in this case will be total/perPage"
    },
    value: {
      type: Number,
      default: 1,
      description: "Pagination value"
    },
    size: {
      type: String,
      default: "",
      description: "Pagination size"
    },
    align: {
      type: String,
      default: "center",
      description: "Pagination alignment (e.g center|start|end)"
    }
  },
  computed: {
    lastPage() {
      return Math.max(1, Math.ceil(this.total / this.perPage));
    }
  },
  watch: {
    // an out-of-range value (e.g. a stale ?page= restored from the URL) would
    // otherwise leave the consumer stuck on an empty page: b-pagination clamps
    // internally but only reports user clicks via 'change'. total === 0 means
    // the count hasn't loaded yet — never clamp against it
    total: {
      immediate: true,
      handler() {
        if (this.total && this.value > this.lastPage) {
          this.$emit('change', this.lastPage);
        }
      }
    }
  },
};
</script>
